import { RECEIVE_SEE_SIMILAR_PRODUCT_ID } from "../modules/similarItems/constants";
import { SET_ITEMS_TYPE } from "../modules/common/constants";
import { ITEMS_TYPE_SIMILAR } from "../../constants";
import { initialise } from "./initialise/similarItems";

export const initialiseSimilarItems =
  ({ productId }) =>
  dispatch => {
    dispatch({
      type: SET_ITEMS_TYPE,
      payload: { itemsType: ITEMS_TYPE_SIMILAR }
    });
    dispatch({
      type: RECEIVE_SEE_SIMILAR_PRODUCT_ID,
      payload: { productId }
    });

    dispatch(initialise());
  };
